import { H2 } from "@datapay-by-datacom/design-system";

export function HistoricalTrendScreen() {
  return (
    <div>
      <H2>Historical Trends</H2>
      <p>Trend chart - coming soon.</p>
    </div>
  );
}
